import { Injectable, Inject, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { TokenService } from './TokenService';

export interface DomainEvent {
	event: string;
	payload: Record<string, unknown>;
}

@Injectable()
export class LiveService implements OnDestroy {

	private socket: Socket | null = null;
	private readonly _events$ = new Subject<DomainEvent>();

	/** Observable stream of all domain events received from the live gateway. */
	readonly events$ = this._events$.asObservable();

	constructor(
		@Inject('liveGatewayUrl') private readonly gatewayUrl: string,
		private readonly tokenService: TokenService,
	) {}

	/** Connect to the live gateway. Safe to call multiple times — no-ops if already connected. */
	connect(): void {
		if (!this.gatewayUrl || this.socket?.connected) return;

		const tokens = this.tokenService.getTokens();
		if (!tokens) return;

		this.socket = io(this.gatewayUrl, {
			transports: ['websocket', 'polling'],
			auth: { token: tokens.accessToken },
			reconnection: true,
			reconnectionDelay: 2000,
			reconnectionDelayMax: 30000,
		});

		this.socket.onAny((event: string, payload: Record<string, unknown>) => {
			this._events$.next({ event, payload });
		});
	}

	/** Disconnect and clean up. */
	disconnect(): void {
		if (this.socket) {
			this.socket.disconnect();
			this.socket = null;
		}
	}

	ngOnDestroy(): void {
		this.disconnect();
	}
}
